import React from "react";
import cn from "classnames";
import { Icon } from "assets/icons";

import styles from "./styles.module.scss";

/**
 * Единая кнопка.
 * variant: primary (обводка) | secondary (заливка) | tertiary (белая) | danger
 */
export const Button = ({
  children,
  icon,
  onClick,
  variant = "primary",
  className,
  disabled,
  loading,
  type = "button",
  title,
}) => (
  <button
    type={type}
    title={title}
    onClick={disabled || loading ? undefined : onClick}
    disabled={disabled}
    className={cn(styles.button, styles[variant], className, {
      [styles.disabled]: disabled || loading,
      [styles.iconOnly]: !!icon && !children,
    })}
  >
    {loading ? (
      <span className={styles.spinner} />
    ) : (
      !!icon && <Icon type={icon} size={16} />
    )}
    {!!children && <span className={styles.label}>{children}</span>}
  </button>
);
